import React, {useState, useEffect} from 'react'
import {Button} from '../../components/Button/Button'
import {JobCard} from '../../components/JobCard/JobCard'
import TextField from '../../components/TextField/TextField'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import {NavText} from '../../components/NavElements'
import {Picker} from '../../components/Picker/Picker'
import classes from './Jobs.module.css'
import {useLocation} from 'react-router'
import {FiChevronsDown, FiChevronsUp} from 'react-icons/fi'
import {Job} from "../../Authenticated/Employee/Types/Job";
import TimeAgo from 'javascript-time-ago'
import {serverConn} from "../../API/apiRequest";
import {Loading} from "../../components/Loading/Loading";
import {NoData} from '../../components/NoData/NoData'

interface Props {
    without?: boolean,
    data?: Array<Job>,
    nostyle?: boolean,
    field?: {
        label: string,
        value: string
    } | null,
    edu?: {
        label: string,
        value: string
    } | null,
    exp?: {
        label: string,
        value: string
    } | null,
    handlesetsearchtext?: any,
    handlesearch?: any,
    setUserexp?: any,
    setUseredu?: any,
    setUserfield?: any,
    handleClearSearch?: any,
    LoadJob?: boolean,
    searchstate?: boolean,
    searchtext?: string,
}

export const Jobs: React.FC<Props> = (props) => {
    const timeAgo = new TimeAgo('ar-EG')
    const {pathname} = useLocation()
    const matches = useMediaQuery('(max-width:610px)')
    const [show, setShow] = useState(false)
    const [unload, setUnload] = useState(!show)
    const [exp, setexp] = useState<{ label: string, value: string }[]>();
    const [edu, setedu] = useState<{ label: string, value: string }[]>();
    const [fields, setfields] = useState<{ label: string, value: string }[]>();
    useEffect(() => {
        window.scrollTo(0, 0)
        serverConn.get(`/config/exp`).then((res) => {
            if(res.status === 200) {
                setexp(res.data.experience);
            }
        })
        serverConn.get(`/config/edu/job`).then((res) => {
            if(res.status === 200) {
                setedu(res.data.edu);
            }
        })
        serverConn.get(`/config/fields`).then((res) => {
            if(res.status === 200) {
                setfields(res.data.fields);
            }
        })
    }, [pathname])
    const showAdvanced = () => {
        if(show) {
            setTimeout(() => setUnload(true), 500)
        }
        setUnload(false)
        setShow(!show)
    }
    return (
            <>


                <div style={{
                    backgroundColor: `${props.nostyle ? "" : '#1D252D'}`,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: "0 20px 0 20px",
                    height: `${useMediaQuery('(max-width:350)') ? 'calc(100vh - 90px)' : ""}`,
                }}>
                    <div
                            style={{
                                height: props.without ? 20 : 120
                            }}
                    />
                    <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                            }}
                    >
                        <div className={classes.searcharea}>
                            <TextField
                                    iconName={'FiSearch'}

                                    textColor='black'
                                    bgColor='white'
                                    width={matches ? 270 : 520}
                                    fontSize={17}
                                    placeholder='عنوان الوظيفة'
                                    handleChange={(e: any) => props.handlesetsearchtext(e.target.value)}
                                    value={props.searchtext ? props.searchtext : ""}
                                    style={{margin: 0, border: 0, borderBottomLeftRadius: 0, paddingTop: 14, paddingBottom: 14}}
                            />
                            {props.searchstate ? (
                                    <div className={classes.clearsearch} onClick={() => props.handleClearSearch()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                             width="30" height="30" x="0" y="0"
                                             viewBox="0 0 512 512"
                                             className="">
                                            <g>
                                                <path xmlns="http://www.w3.org/2000/svg"
                                                      d="m416 512h-320c-53.023438 0-96-42.976562-96-96v-320c0-53.023438 42.976562-96 96-96h320c53.023438 0 96 42.976562 96 96v320c0 53.023438-42.976562 96-96 96zm0 0"
                                                      fill="#ffe6e2" data-original="#ffe6e2" className=""></path>
                                                <path
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        d="m271.089844 256 64.109375-64.113281c4.160156-4.160157 4.160156-10.910157 0-15.085938-4.160157-4.175781-10.910157-4.160156-15.085938 0l-64.113281 64.109375-64.113281-64.109375c-4.160157-4.160156-10.910157-4.160156-15.085938 0-4.175781 4.160157-4.160156 10.910157 0 15.085938l64.109375 64.113281-64.109375 64.113281c-4.160156 4.160157-4.160156 10.910157 0 15.085938 2.078125 2.082031 4.816407 3.121093 7.535157 3.121093 2.734374 0 5.457031-1.039062 7.535156-3.121093l64.128906-64.109375 64.113281 64.109375c2.078125 2.082031 4.816407 3.121093 7.535157 3.121093s5.457031-1.039062 7.535156-3.121093c4.160156-4.160157 4.160156-10.910157 0-15.085938zm0 0"
                                                        fill="#fc573b" data-original="#fc573b"></path>
                                            </g>
                                        </svg>
                                    </div>) : ""}
                        </div>
                        <div className={classes.adIcon} onClick={showAdvanced}>
                            {show ?
                                    <FiChevronsUp size={30} color='white'/>
                                    :
                                    <FiChevronsDown size={30} color='white'/>}
                        </div>
                    </div>

                    <div className={show ? classes.advancedSearch : classes.hide}>
                        {!unload &&
                            <>
                                <div className={'mx-2'}>
                                    <p style={labelStyle}>الخبرة</p>
                                    <Picker Width={150} color='#C4C4C4'
                                            isSearchable={true}
                                            isClearable={true}
                                            value={props.exp ? props.exp : null}
                                            onChange={(e) => props.setUserexp(e)}
                                            options={exp} placeholder='الخبرة العملية'/>
                                </div>
                                <div className={'mx-2'}>
                                    <p style={labelStyle}>التعليم</p>
                                    <Picker Width={150}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={props.edu ? props.edu : null}
                                            onChange={(e) => props.setUseredu(e)}
                                            color='#C4C4C4' options={edu} placeholder='التعليم'/>
                                </div>
                                <div className={'mx-2'}>
                                    <p style={labelStyle}>المجالات</p>
                                    <Picker Width={150}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={props.field ? props.field : null}
                                            onChange={(e) => props.setUserfield(e)}
                                            color='#C4C4C4' options={fields} placeholder='المجالات'/>
                                </div>
                            </>}
                    </div>
                    <Button
                            onPress={() => props.edu || props.exp || props.field || props.searchtext ? props.handlesearch() : null}
                            height={matches ? 40 : 42}
                            width={matches ? 85 : 100}
                            borderRadius={8}
                            fontSize={18}
                            disabled={!(props.edu || props.exp || props.field || props.searchtext)}
                            color='#6EB66C'
                    >بحث</Button>


                    {props.LoadJob ? (<Loading></Loading>) : (
                            <div className={props.data && props.data.length > 0 ? classes.jobsContainer : ' h-100 d-flex align-items-center '}>
                                {props.data && props.data.length > 0 ? props.data.map((j, index) =>
                                        <NavText key={index} to={{
                                            pathname: `${window.location.href.includes('employee') ? `/employee/job/${j.id}` : `/job/${j.id}`}`,
                                            state: {without: props.without}
                                        }}><JobCard
                                                title={j.title}
                                                companyName={j.companyName}
                                                CompanyImage={j.companyImage}
                                                time={(timeAgo.format(Date.now() - (Date.now() - new Date(j.createdAt).getTime()))).toString().replace("قبل", '')}
                                                jobCategory={j.field}
                                                jobTime={j.type}
                                        /> </NavText>) : (
                                        <div className={'h-100 d-flex align-items-center'}><NoData/></div>)}
                            </div>)}

                </div>
            </>
    )
}
const labelStyle: React.CSSProperties = {
    margin: 0,
    padding: 0,
    color: 'white',
    textAlign: 'right',
    paddingRight: 5
} 